import { getRandomInt, removeAllChildNodes } from "../../helpers";

export class RestaurantFilters {
	constructor(el) {
		if (!el) return;
		this.filtersWrapper = el;
		this.selectElements = Array.from(
			this.filtersWrapper.querySelectorAll("select")
		);

		if (this.selectElements.length === 0) return;
		this.results = document.querySelector(this.filtersWrapper.dataset.results);
		this.mapResults = document.querySelector(
			this.filtersWrapper.dataset.mapResults
		);

		this.items = Array.from(this.results.querySelectorAll(".item"));
		this.mapItems = Array.from(this.mapResults.querySelectorAll(".item-card"));
		this.mapItemsWrapper = this.mapResults.querySelector(".swiper-wrapper");

		this.state = [];
		this.selectedItems = [...this.items];
		this.selectedMapItems = [...this.mapItems];

		this.closeBtns = Array.from(this.mapItems).map(el => {
			return el.querySelector('.closingBtnMap')
		})

		this.init();
		this.events();
	}

	init() {
		this.selectedItems.forEach((item) => item.classList.add("active"));
		// this.selectedMapItems.forEach((item) => item.classList.add("active"));
		this.mapSwiper = this.mapResults.querySelector(".swiper").swiper;

		this.state["hotel"] = "all";
		this.state["type"] = "all";
		this.state["theme"] = "all";
	}

	clearItems() {
		this.items.map((item) => {
			item.classList.add("!hidden");
			item.classList.remove("active");
		});
	}

	updateState(taxonomy = "", term = "") {
		if (taxonomy.length === 0 || term.length === 0) return;
		this.state[taxonomy] = term;
		this.filterResults.bind(this)();

		let j = 1;
		this.selectedItems.forEach((element) => {
			element.classList.replace("md:col-span-4", "md:col-span-6");
			if (
				this.selectedItems.length > 3 &&
				this.selectedItems.length % 2 !== 0
			) {
				if (this.selectedItems.length - j < 3) {
					element.classList.replace("md:col-span-6", "md:col-span-4");
				}
			}
			j++;
		});
	}

	filterListResults() {
		this.clearItems.bind(this)();
		this.selectedItems = [...this.items];

		Object.keys(this.state).forEach((key) => {
			const stateValue = this.state[key];
			if ("all" === stateValue) return;
			// console.log(
			// 	`Searching %c${key} %c${stateValue}`,
			// 	"color: yellow",
			// 	"color: red"
			// );

			this.selectedItems = this.selectedItems.filter(
				(item) => item.dataset[key] && item.dataset[key].includes(stateValue)
			);
		});

		// console.log(this.selectedItems);

		this.selectedItems.forEach((item) => {
			item.classList.remove("!hidden");
			item.classList.add("active");
		});
	}

	filterMapResults() {
		// this.clearItems.bind(this)();
		this.selectedMapItems = [...this.mapItems];

		Object.keys(this.state).forEach((key) => {
			const stateValue = this.state[key];
			if ("all" === stateValue) return;
			// console.log(
			// 	`Searching %c${key} %c${stateValue}`,
			// 	"color: yellow",
			// 	"color: red"
			// );

			this.selectedMapItems = this.selectedMapItems.filter(
				(item) => item.dataset[key] && item.dataset[key].includes(stateValue)
			);
		});

		const allMapItems = [...this.mapItems];

		removeAllChildNodes(this.mapItemsWrapper);

		let gmapLocations = {};
		this.selectedMapItems.forEach((item) => {
			allMapItems.forEach((el) => {
				if (el === item) {
					this.mapItemsWrapper.append(el);
				}
			});

			let rnd = getRandomInt(100000);

			gmapLocations[rnd] = {
				lat: item.dataset.locationLat,
				lng: item.dataset.locationLng,
				address: "",
			};
		});

		this.mapSwiper.update();

		window.dispatchEvent(
			new CustomEvent("gmap.setMarkers", {
				detail: { locations: gmapLocations },
			})
		);
	}

	filterResults() {
		this.filterListResults.bind(this)();
		this.filterMapResults.bind(this)();
	}

	onFilterChange(ev) {
		this.updateState.bind(this)(
			ev.currentTarget.dataset.filter,
			ev.target.value
		);
		window.dispatchEvent(new Event("resize"));
	}

	onCloseBtnClick(event) {
		this.mapItemsWrapper.classList.add('hidden')
	}

	events() {
		this.selectElements.map((element) => {
			element.addEventListener("change", this.onFilterChange.bind(this), false);
		});

		this.closeBtns && this.closeBtns.map(el => {
			el.addEventListener('click', this.onCloseBtnClick.bind(this), false)
		});
	}
}

export class CareersFilters {
	constructor(el) {
		if (!el) return;
		this.filtersWrapper = el;
		this.selectElements = Array.from(
			this.filtersWrapper.querySelectorAll("select")
		);

		if (this.selectElements.length === 0) return;
		this.results = document.querySelector(this.filtersWrapper.dataset.results);

		this.items = Array.from(this.results.querySelectorAll(".item"));

		this.state = [];
		this.selectedItems = [...this.items];

		this.init();
		this.events();
	}

	init() {
		this.selectedItems.forEach((item) => item.classList.add("active"));
		// this.selectedMapItems.forEach((item) => item.classList.add("active"));

		this.state["hotel"] = "all";
		this.state["category"] = "all";
	}

	clearItems() {
		this.items.map((item) => {
			item.classList.add("!hidden");
			item.classList.remove("active");
		});
	}

	updateState(taxonomy = "", term = "") {
		if (taxonomy.length === 0 || term.length === 0) return;
		this.state[taxonomy] = term;
		this.filterResults.bind(this)();
	}

	filterListResults() {
		this.clearItems.bind(this)();
		this.selectedItems = [...this.items];

		Object.keys(this.state).forEach((key) => {
			const stateValue = this.state[key];
			if ("all" === stateValue) return;
			// console.log(
			// 	`Searching %c${key} %c${stateValue}`,
			// 	"color: yellow",
			// 	"color: red"
			// );

			this.selectedItems = this.selectedItems.filter(
				(item) => item.dataset[key] && item.dataset[key].includes(stateValue)
			);
		});

		this.selectedItems.forEach((item) => {
			item.classList.remove("!hidden");
			item.classList.add("active");
		});
	}

	filterResults() {
		this.filterListResults.bind(this)();
	}

	onFilterChange(ev) {
		this.updateState.bind(this)(
			ev.currentTarget.dataset.filter,
			ev.target.value
		);

		window.dispatchEvent(new Event("resize"));
	}

	events() {
		this.selectElements.map((element) => {
			element.addEventListener("change", this.onFilterChange.bind(this), false);
		});
	}
}
